const LayerFrontSvg = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14362_31112)">
        <path
          d="M23.4375 19.2708H15.1042V9.37495H17.186C17.3762 9.37506 17.5629 9.32308 17.7256 9.22465C17.8884 9.12621 18.0211 8.98508 18.1094 8.81656C18.1977 8.64804 18.2381 8.45857 18.2263 8.26871C18.2145 8.07884 18.1509 7.89583 18.0425 7.73953L13.3576 0.969893C13.2616 0.831243 13.1334 0.717928 12.9841 0.639661C12.8347 0.561393 12.6686 0.520508 12.5 0.520508C12.3314 0.520508 12.1653 0.561393 12.0159 0.639661C11.8666 0.717928 11.7384 0.831243 11.6425 0.969893L6.95751 7.73953C6.84921 7.89586 6.78576 8.07885 6.77404 8.26867C6.76231 8.45848 6.80276 8.64789 6.89099 8.81636C6.97922 8.98484 7.11188 9.12595 7.27459 9.22441C7.43729 9.32288 7.62384 9.37493 7.81402 9.37495H9.89584V19.2708H1.56251C1.28634 19.2711 1.02157 19.3809 0.826291 19.5762C0.631009 19.7715 0.521161 20.0363 0.520844 20.3124V23.4374C0.521161 23.7136 0.631009 23.9784 0.826291 24.1737C1.02157 24.3689 1.28634 24.4788 1.56251 24.4791H23.4375C23.7137 24.4788 23.9784 24.3689 24.1737 24.1737C24.369 23.9784 24.4789 23.7136 24.4792 23.4374V20.3124C24.4789 20.0363 24.369 19.7715 24.1737 19.5762C23.9784 19.3809 23.7137 19.2711 23.4375 19.2708Z"
          fill="black"
          fillOpacity="0.95"
        />
        <path
          d="M23.4375 12.5H16.1458V17.7083H23.4375C23.7137 17.708 23.9784 17.5982 24.1737 17.4029C24.369 17.2076 24.4789 16.9428 24.4792 16.6667V13.5417C24.4789 13.2655 24.369 13.0007 24.1737 12.8054C23.9784 12.6102 23.7137 12.5003 23.4375 12.5Z"
          fill="#878787"
        />
        <path
          d="M1.56251 17.7083H8.85418V12.5H1.56251C1.28634 12.5003 1.02157 12.6102 0.826291 12.8054C0.631009 13.0007 0.521161 13.2655 0.520844 13.5417V16.6667C0.521161 16.9428 0.631009 17.2076 0.826291 17.4029C1.02157 17.5982 1.28634 17.708 1.56251 17.7083Z"
          fill="#878787"
        />
      </g>
    </svg>
  );
};

export default LayerFrontSvg;
